import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '@qwyk/core';
import { IconName } from '@fortawesome/angular-fontawesome';

@Pipe({
    standalone: true,
    name: 'productIcon',
})
export class ProductIconPipe implements PipeTransform {
    private readonly _icons: { [index: string]: IconName } =
        Constants.PRODUCT_ICONS;

    transform(value: string): IconName {
        return this._icons[value];
    }
}
